module.exports = __webpack_public_path__ + "img/06_rocks-gavron_NEW.33d61d5d.jpg";